import React from 'react'
import { isMobile } from 'react-device-detect'
import Icon from '../Icon'
import { ZINDEX, SOCIAL_URL } from '../../utils/constant'
import Link from 'next/link'
import { emitGA } from '../../utils/gtm'
import { withTranslation } from '../../i18n'

const style = {
  position: 'fixed',
  bottom: 0,
  right: '5pt',
  fontSize: 14,
  // height: 40,
  // lineHeight: 40,
  boxShadow: 'rgba(50, 58, 69, 0.5) 0px 1px 4px 0px',
  zIndex: ZINDEX.HIGHEST,
  padding: '10px 16px',
  fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
  fontWeight: 400,
  backgroundColor: 'rgb(13, 96, 255)',
  color: 'white',
  borderRadius: '10px 10px 0px 0px'
}
const handleOnClick = (event, data) => emitGA(event, data)

export const ScheduleCalendar = ({ t }) => !isMobile &&
  <a href={SOCIAL_URL.CALENDAR_URL} rel="noopener noreferrer" target="_blank"
    onClick={() => handleOnClick('CLICK_CHAT_ICON', { action: 'Schedule' })}>
    <span style={style}>
      <Icon className="mr-2" name='calendar-call'/>
      <span>{t`Hẹn lịch tư vấn`}</span>
    </span>
  </a>

export default withTranslation('common')(ScheduleCalendar)
